import { marked } from "marked";

const renderer = new marked.Renderer();

renderer.link = function (href: string, title: string | null, text: string) {
  const titleAttr = title ? ` title="${title}"` : "";
  return `<a href="${href}"${titleAttr} target="_blank" rel="noopener noreferrer">${text}</a>`;
};

marked.setOptions({
  renderer,
  breaks: true,
  gfm: true,
  pedantic: false,
});

const normalizeContent = (content: string): string => {
  if (!content) return "";

  let trimmed = content.trim();

  const codeBlockPattern = /^```(?:markdown|md)?\s*\n?([\s\S]*?)\n?```$/;
  const match = trimmed.match(codeBlockPattern);
  if (match) {
    trimmed = match[1].trim();
  }

  const lines = trimmed.split("\n");

  const minIndent = lines
    .filter((line) => line.trim().length > 0)
    .reduce((min, line) => {
      const match = line.match(/^(\s*)/);
      const indent = match ? match[1].length : 0;
      return Math.min(min, indent);
    }, Infinity);

  if (minIndent === Infinity || minIndent === 0) {
    return trimmed;
  }

  const normalized = lines
    .map((line) => (line.length > 0 ? line.slice(minIndent) : line))
    .join("\n")
    .trim();

  return normalized;
};

export const parseMarkdown = (content: string): string => {
  const normalized = normalizeContent(content);
  return marked(normalized) as string;
};

